import {
  addEmailAttachmentRequest,
  deleteEmailAttachmentRequest,
  downloadEmailAttachmentRequest,
  editEmailAttachmentRequest,
  getEmailAttchListRequest
} from '../api/requests'
import * as types from './types'

export const getEmailAttachList = (appId: string) => ({
  type: [types.GET_EMAIL_ATTCH_LIST, types.GET_EMAIL_ATTCH_LIST_SUCCESS, types.GET_EMAIL_ATTCH_LIST_FAILED],
  payload: {
    api: 'support',
    request: getEmailAttchListRequest(appId)
  },
  Data: []
})

export const addEmailAttachment = (
  appId: number,
  attachmentDesc: string,
  createdByName: string,
  updatedByName: string,
  attachmentFile: File
) => ({
  type: [types.ADD_EMAIL_ATTCH, types.ADD_EMAIL_ATTCH_SUCCESS, types.ADD_EMAIL_ATTCH_FAILED],
  payload: {
    api: 'support',
    request: addEmailAttachmentRequest(appId, attachmentDesc, createdByName, updatedByName, attachmentFile)
  },
  Data: {}
})

export const editEmailAttachment = (attachmentDesc: string, attachmentUUID: string, updatedByName: string, attachmentFile?: File) => ({
  type: [types.EDIT_EMAIL_ATTCH, types.EDIT_EMAIL_ATTCH_SUCCESS, types.EDIT_EMAIL_ATTCH_FAILED],
  payload: {
    api: 'support',
    request: editEmailAttachmentRequest(attachmentDesc, attachmentUUID, updatedByName, attachmentFile)
  },
  Data: {}
})

export const deleteEmailAttachment = (attachmentUUID: string) => ({
  type: [types.DELETE_EMAIL_ATTCH, types.DELETE_EMAIL_ATTCH_SUCCESS, types.DELETE_EMAIL_ATTCH_FAILED],
  payload: {
    api: 'support',
    request: deleteEmailAttachmentRequest(attachmentUUID)
  },
  Data: {}
})

export const downloadEmailAttachment = (attachmentUUID: string) => ({
  type: [types.DOWNLOAD_EMAIL_ATTCH, types.DOWNLOAD_EMAIL_ATTCH_SUCCESS, types.DOWNLOAD_EMAIL_ATTCH_FAILED],
  payload: {
    api: 'support',
    request: downloadEmailAttachmentRequest(attachmentUUID)
  }
})
